
(function() {
  var result = { translations: { "es": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Acciones" }, "tag": { "remove": "Eliminar etiqueta" }, "Select": { "noResults": "No se encontraron resultados", "searchPlaceholder": "Buscar...", "clearSelections": "Borrar selecciones" }, "ErrorMessage": { "error": { "title": "No encontramos lo que buscas." }, "notFound": { "title": "No todos los que deambulan est\xE1n perdidos." }, "badRequest": { "title": "Se produjo un problema al cargar esta p\xE1gina." }, "expired": { "title": "Lo sentimos." }, "sessionId": { "prefix": "ID de la sesi\xF3n: " } }, "ProgressSteps": { "completedStep": "Paso completado", "incompleteStep": "Paso incompleto" }, "Paginator": { "label": "Paginaci\xF3n", "pageNumber": { "currentIndicator": "Est\xE1s actualmente en", "description": "P\xE1gina " }, "firstPage": { "label": "Primero", "description": "Primera p\xE1gina" }, "previousPage": { "label": "Anterior", "description": "P\xE1gina anterior" }, "nextPage": { "label": "Siguiente", "description": "P\xE1gina siguiente" }, "lastPage": { "label": "\xDAltima", "description": "\xDAltima p\xE1gina" } }, "Datagrid": { "noData": { "Title": "No hay datos disponibles", "Description": "No hay datos disponibles para mostrar." }, "noResults": { "Title": "No se encontraron resultados", "Description": "Prueba ajustando la b\xFAsqueda y los filtros para encontrar lo que est\xE1s buscando.", "ClearActionLabel": "Borrar b\xFAsqueda y filtros" }, "toolbar": { "selectedRows": { "one": "{{count}} fila seleccionada", "other": "{{count}} de filas seleccionadas", "clearSelection": "Borrar selecci\xF3n", "selectAll": "Seleccionar las {{totalRows}} filas" }, "search": { "placeholder": "Buscar", "label": "Buscar", "clearSearch": "Borrar b\xFAsqueda" } }, "pagination": { "visibleRows": "{{visibleRows}} de {{totalRows}} resultados", "itemsPerPage": "Elementos por p\xE1gina", "countPerPage": { "one": "{{count}} por p\xE1gina", "other": "{{count}} por p\xE1gina", "many": "{{count}} por p\xE1gina" } }, "SkeletonGrid": { "loading": "Cargando" }, "DataGridColumnManagementPanel": { "description": "Elige las propiedades que se mostrar\xE1n como columnas. A continuaci\xF3n, desplaza hacia arriba o hacia abajo o arrastra y suelta las propiedades para cambiar el orden en el que se mostrar\xE1n.", "removeAllColumns": "Eliminar todas las columnas", "update": "Actualizar", "cancel": "Cancelar", "edit": "Editar columnas" } } }, "ui": { "UIAbstractPageSection": { "page": "Secci\xF3n de la p\xE1gina" }, "UICarousel": { "current": "Mostrando elemento {{currentStepDisplayNumber}} de {{totalSteps}}", "prev": "Anterior", "next": "Siguiente", "tip": "Utiliza las teclas de flecha para ver otros elementos" }, "UIColorSwatch": { "label": "Selector de colores {{value}}", "noColorLabel": "Selector crom\xE1tico. No se ha seleccionado un color." }, "UIButtonCollapser": { "dropdownLabel": "Acciones" }, "UIErrorMessage": { "error": { "title": "No encontramos lo que buscas." }, "notFound": { "title": "No todos los que deambulan est\xE1n perdidos." }, "badRequest": { "title": "Se produjo un problema al cargar esta p\xE1gina." }, "expired": { "title": "Lo sentimos." } }, "UIPanelNavigator": { "backButton": "Ir a la pantalla anterior" }, "UILoadingSpinner": { "busyText": "Cargando", "completedText": "Cargada" }, "UISideNav": { "navigationLandmark": "Secundario" }, "UISortTH": { "ascendingSort": "Orden ascendente. Presiona para cambiar a orden descendente.", "descendingSort": "Orden descendente. Presiona para cambiar a orden ascendente.", "pressToSort": "Presiona para ordenar." }, "autosizedTextInput": { "charactersRemaining": "{{value}} caracteres restantes" }, "time": { "today": "Hoy a las {{time}}", "yesterday": "Ayer a las {{time}}", "datetime": "{{date}} a la(s) {{time}}" }, "progress": { "percentComplete": "{{percent}} completo" }, "datePicker": { "dateSelected": "Se seleccion\xF3 {{date}}.", "noDateSelected": "No hay fecha seleccionada.", "dateBelowMin": "Debes elegir una fecha m\xE1s reciente", "dateAboveMax": "Debes elegir una fecha m\xE1s antigua", "invalidDate": "Fecha no v\xE1lida", "today": "Hoy", "clear": "Borrar", "placeholder": { "month": "MM", "day": "DD", "year": "AAAA" }, "nextMonth": "Mes siguiente", "prevMonth": "Mes anterior" }, "dateRange": { "startDate": "Inicio", "endDate": "Finalizaci\xF3n", "endDateBeforeStartDate": "La fecha de fin debe ser posterior a la fecha de inicio.", "startDateAfterEndDate": "La fecha de inicio debe ser anterior a la fecha de fin.", "to": "para" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "... y {{count}} m\xE1s.", "loadMore": "Cargar m\xE1s" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "A\xF1adir" }, "UIAvatarHoverlay": { "text": "Cambiar la foto" }, "UIChangeArrow": { "decrease": "Disminuci\xF3n de", "increase": "Aumento de" }, "UICopyInput": { "label": "Copiar", "title": "Copiar en el portapapeles", "tooltipCopied": "Copiado" }, "UIConfirm": { "defaultConfirm": "S\xED", "defaultReject": "No" }, "UICloseButton": { "label": "Cerrar" }, "UIDateRangePicker": { "rangeType": { "ALL": "Todo", "THIS_DAY": "Hoy", "LAST_DAY": "Ayer", "THIS_WEEK": "Esta semana", "LAST_WEEK": "Semana pasada", "THIS_MONTH": "Este mes", "LAST_MONTH": "Mes pasado", "LAST_THIRTY_DAYS": "\xDAltimos 30 d\xEDas", "LAST_THREE_MONTHS": "\xDAltimos 3 meses", "THIS_QUARTER": "Este trimestre", "LAST_QUARTER": "Trimestre pasado", "THIS_YEAR": "Este a\xF1o", "LAST_YEAR": "A\xF1o pasado", "CUSTOM": "Per\xEDodo personalizado" } }, "UIDropdownSelect": { "placeholder": "No has seleccionado ning\xFAn valor" }, "UIEditableControls": { "cancel": "Cancelar", "save": "Guardar" }, "UIExpandableText": { "collapseButtonText": "Ver menos", "expandButtonText": "Ver m\xE1s" }, "UIFileInput": { "defaultChangeLabel": "Cambiar archivo", "defaultSelectLabel": "Elegir archivo" }, "UIIconRating": { "ariaValueText": "{{value}} de {{maxValue}}" }, "UILink": { "externalTitle": "El enlace se abre en una ventana nueva" }, "UILoading": { "title": "Cargando\u2026" }, "UILockBadge": { "title": "Esta caracter\xEDstica est\xE1 bloqueada" }, "UIPaginator": { "label": "Paginaci\xF3n", "pageNumber": { "currentIndicator": "Est\xE1s actualmente en", "description": "P\xE1gina " }, "firstPage": { "label": "Primero", "description": "Primera p\xE1gina" }, "previousPage": { "label": "Anterior", "description": "P\xE1gina anterior" }, "nextPage": { "label": "Siguiente", "description": "P\xE1gina siguiente" }, "lastPage": { "label": "\xDAltima", "description": "\xDAltima p\xE1gina" } }, "UIPreviousButton": { "label": "Anterior" }, "UINextButton": { "label": "Siguiente" }, "UINumberRating": { "lowRangeLabel": "Muy en desacuerdo", "highRangeLabel": "Muy de acuerdo" }, "UISearchableSelectInput": { "placeholder": "Buscar" }, "UISearchInput": { "placeholder": "Buscar", "minimumSearchMessage": { "one": "Escribe 1 car\xE1cter m\xE1s", "other": "Escribe {{count}} caracteres m\xE1s", "many": "Escribe {{count}} de caracteres m\xE1s" }, "clearButton": "Borrar entrada" }, "UISelect": { "allOptionsSelected": "Todas las opciones est\xE1n seleccionadas", "createOption": "Crear opci\xF3n de \"{{label}}\"", "plusMore": "+ {{count}} m\xE1s", "andMore": "... y {{count}} m\xE1s.", "loadMore": "Cargar m\xE1s", "noResults": "No se encontraron resultados", "placeholder": "Buscar", "typeToSearch": "Escribe lo que deseas buscar" }, "UITable": { "selectableTableRow": { "toggleSelection": "Invertir selecci\xF3n de la fila" } }, "UITabs": { "moreDropdownLabel": "M\xE1s" }, "UITeaseNotification": { "optionsButtonTooltipText": "Mostrar opciones" }, "UITimePicker": { "placeholder": "Seleccionar una hora" }, "UIToggle": { "checkedLabel": "ACTIVADA", "uncheckedLabel": "DESACTIVADA" }, "UITypeahead": { "noMatchesFound": "No se encontraron coincidencias", "noOptions": "Ninguna" }, "UIWizard": { "back": "Anterior", "cancel": "Cancelar", "done": "Listo", "next": "Siguiente", "stepCount": "Paso {{stepNumber}} de {{stepCount}}" }, "XSSTooltip": { "explanation": "Este enlace ha sido desactivado por tu seguridad." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "es": "static-1.5025"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5025",
    "ar-eg": "static-1.5025",
    "bg": "static-1.5025",
    "bn": "static-1.5025",
    "ca-es": "static-1.5025",
    "cs": "static-1.5025",
    "da": "static-1.5025",
    "de": "static-1.5025",
    "el": "static-1.5025",
    "en-gb": "static-1.5025",
    "en": "static-1.5025",
    "es-mx": "static-1.5025",
    "es": "static-1.5025",
    "et": "static-1.5025",
    "fi": "static-1.5025",
    "fr-ca": "static-1.5025",
    "fr": "static-1.5025",
    "he-il": "static-1.5025",
    "hi": "static-1.5025",
    "hr": "static-1.5025",
    "hu": "static-1.5025",
    "id": "static-1.5025",
    "it": "static-1.5025",
    "ja": "static-1.5025",
    "ko": "static-1.5025",
    "lt": "static-1.5025",
    "ms": "static-1.5025",
    "nl": "static-1.5025",
    "no": "static-1.5025",
    "pl": "static-1.5025",
    "pt-br": "static-1.5025",
    "pt-pt": "static-1.5025",
    "ro": "static-1.5025",
    "ru": "static-1.5025",
    "sk": "static-1.5025",
    "sl": "static-1.5025",
    "sv": "static-1.5025",
    "th": "static-1.5025",
    "tl": "static-1.5025",
    "tr": "static-1.5025",
    "uk": "static-1.5025",
    "vi": "static-1.5025",
    "zh-cn": "static-1.5025",
    "zh-hk": "static-1.5025",
    "zh-tw": "static-1.5025"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:es', {version: 'static-1.5025'}); }
})();



(function() {
  var result = { translations: { "es": { "placeholder": "marcador de posici\xF3n" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "es": "static-3.6475"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6475",
    "ar-eg": "static-3.6475",
    "bg": "static-3.6475",
    "bn": "static-3.6475",
    "ca-es": "static-3.6475",
    "cs": "static-3.6475",
    "da": "static-3.6475",
    "de": "static-3.6475",
    "el": "static-3.6475",
    "en-gb": "static-3.6475",
    "en": "static-3.6475",
    "es-mx": "static-3.6475",
    "es": "static-3.6475",
    "et": "static-3.6475",
    "fi": "static-3.6475",
    "fr-ca": "static-3.6475",
    "fr": "static-3.6475",
    "he-il": "static-3.6475",
    "hi": "static-3.6475",
    "hr": "static-3.6475",
    "hu": "static-3.6475",
    "id": "static-3.6475",
    "it": "static-3.6475",
    "ja": "static-3.6475",
    "ko": "static-3.6475",
    "lt": "static-3.6475",
    "ms": "static-3.6475",
    "nl": "static-3.6475",
    "no": "static-3.6475",
    "pl": "static-3.6475",
    "pt-br": "static-3.6475",
    "pt-pt": "static-3.6475",
    "ro": "static-3.6475",
    "ru": "static-3.6475",
    "sk": "static-3.6475",
    "sl": "static-3.6475",
    "sv": "static-3.6475",
    "th": "static-3.6475",
    "tl": "static-3.6475",
    "tr": "static-3.6475",
    "uk": "static-3.6475",
    "vi": "static-3.6475",
    "zh-cn": "static-3.6475",
    "zh-hk": "static-3.6475",
    "zh-tw": "static-3.6475"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:es', {version: 'static-3.6475'}); }
})();



(function() {
  var result = { translations: { "es": { "app": { "htmlTitle": "IU de enlaces virales", "welcomeHome": "Hola, {{ firstName }}", "yourAppIsReady": "Tu aplicaci\xF3n est\xE1 lista", "aSecondPage": "Una segunda p\xE1gina para contener m\xE1s contenido.", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Llena esta p\xE1gina vac\xEDa con ", createElement( options, "Link", props.linkProps, "componentes" ), " en ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Crea tus propios formularios gratuitos</strong> para generar leads desde tu sitio web." }, "liveChat": { "linkCta": "<strong>Agrega live chat.</strong> Con\xE9ctate con los visitantes. Gratis.", "ariaLabel": "Agrega live chat. Con\xE9ctate con los visitantes. Gratis." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Agrega un chat en directo.</strong> Contacta con los visitantes de manera gratuita.", "ariaLabel": "[Int] Agrega un chat en directo. Contacta con los visitantes de manera gratuita." }, "meetings": { "linkCta": "<strong>Crea tu p\xE1gina de reserva de reuniones gratuita</strong> para programar reuniones de forma m\xE1s r\xE1pida." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "es": "static-1.4152"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.4152",
    "ar-eg": "static-1.4152",
    "bg": "static-1.4152",
    "bn": "static-1.4152",
    "ca-es": "static-1.4152",
    "cs": "static-1.4152",
    "da": "static-1.4152",
    "de": "static-1.4152",
    "el": "static-1.4152",
    "en-gb": "static-1.4152",
    "en": "static-1.4152",
    "es-mx": "static-1.4152",
    "es": "static-1.4152",
    "et": "static-1.4152",
    "fi": "static-1.4152",
    "fr-ca": "static-1.4152",
    "fr": "static-1.4152",
    "he-il": "static-1.4152",
    "hi": "static-1.4152",
    "hr": "static-1.4152",
    "hu": "static-1.4152",
    "id": "static-1.4152",
    "it": "static-1.4152",
    "ja": "static-1.4152",
    "ko": "static-1.4152",
    "lt": "static-1.4152",
    "ms": "static-1.4152",
    "nl": "static-1.4152",
    "no": "static-1.4152",
    "pl": "static-1.4152",
    "pt-br": "static-1.4152",
    "pt-pt": "static-1.4152",
    "ro": "static-1.4152",
    "ru": "static-1.4152",
    "sk": "static-1.4152",
    "sl": "static-1.4152",
    "sv": "static-1.4152",
    "th": "static-1.4152",
    "tl": "static-1.4152",
    "tr": "static-1.4152",
    "uk": "static-1.4152",
    "vi": "static-1.4152",
    "zh-cn": "static-1.4152",
    "zh-hk": "static-1.4152",
    "zh-tw": "static-1.4152"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:es', {version: 'static-1.4152'}); }
})();


